import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  postQuestion,
  resetPostQuestionState,
} from "../../store/postQuestionSlice";
import {
  Overlay,
  ModalWrapper,
  ModalHeader,
  ModalTitle,
  ModalBody,
  ModalFooter,
  Label,
  Required,
  TextArea,
  CounterText,
  CloseButton,
  PostButton,
} from "./PostQuestionModal.styles";
import { useMsal } from "@azure/msal-react";
import { TECHNOLOGY_SKILL_MAP } from "../../data/technologySkills";
import { Autocomplete, TextField } from "@mui/material";
import { createTheme } from "@mui/material/styles";
import { ThemeProvider } from "@mui/material/styles";
import { searchEmployees } from "../../store/employeeSlice";
const MAX_CHARS = 2000;

function PostQuestionModal({ open, onClose, onPostSuccess }) {
const theme = createTheme({
    typography: {
      fontFamily: "Graphik-Regular",
    },
  });
  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [open]);

  const dispatch = useDispatch();
  const { instance, accounts } = useMsal();

  const account = accounts[0];
  const designation =
  account?.idTokenClaims?.jobTitle ||
  null;
  const { loading, success } = useSelector(
    (state) => state.postQuestion
  );
  const { employeeOptions, loading: employeeLoading } = useSelector(
  (state) => state.employees
  );
  const [form, setForm] = useState({
    technology: "",
    skill: "",
    body: "",
    taggedUsers: []
  });
  const debounceRef = useRef(null);
  const handleEmployeeSearch = (value) => {

  if (debounceRef.current) {
    clearTimeout(debounceRef.current);
  }

  debounceRef.current = setTimeout(() => {

    if (value.length < 2) return;

    dispatch(searchEmployees(value));

  }, 300);
};

  useEffect(() => {
    return () => {
      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }
    };
  }, []);
  if (!open) return null;
  const technologies = Object.keys(TECHNOLOGY_SKILL_MAP);
  const skills =
    TECHNOLOGY_SKILL_MAP[form.technology] || [];

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "body" && value.length > MAX_CHARS) return;

    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleClose = () => {
    setForm({ technology: "", skill: "", body: "", taggedUsers: [] });
    onClose();
  };

  const isDisabled =
    !form.technology || !form.skill || !form.body.trim();

  const handlePostQuestion = async () => {
  const payload = {
    ...form,
    taggedUsers: form.taggedUsers.map(user => user.eid),
    designation,
  };

  const result = await dispatch(postQuestion(payload));

    if (postQuestion.fulfilled.match(result)) {
      onPostSuccess();
      handleClose();
      dispatch(resetPostQuestionState());
    }
  };
  
  return (
    <ThemeProvider theme={theme}>
    <Overlay>
      <ModalWrapper>
        <ModalHeader>
          <ModalTitle>Post Question</ModalTitle>
        </ModalHeader>
        <ModalBody>
          <div>
            <Label>
              Select Business Group <Required>*</Required>
            </Label>
            <Autocomplete
              options={technologies}
              value={form.technology || null}
              onChange={(event, newValue) => {
                setForm((prev) => ({
                  ...prev,
                  technology: newValue || "",
                  skill: ""
                }));
              }}
              popupIcon={
                <img
                  src={process.env.PUBLIC_URL + "/images/Home/sort-arrow.svg"}
                  alt="dropdown"
                  style={{ width: 16, height: 16 }}
                />
              }
              forcePopupIcon={true}
              ListboxProps={{
                sx: {
                  "& .MuiAutocomplete-option": {
                    fontSize: "14px",
                    padding: "6px 12px",
                  },
                },
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Group"
                  fullWidth
                  size="small"
                  sx={{
                    width: 300,
                    "& .MuiOutlinedInput-root": {
                      height: 32,
                      borderRadius: 0,
                      fontSize: "14px",
                      display: "flex",
                      alignItems: "center",
                    },
                    "& .MuiInputBase-input": {
                      padding: "6px 10px",
                    },
                    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#7500C0",
                    },

                    "& .MuiInputLabel-root.Mui-focused": {
                      color: "#7500C0",
                    },
                    "& .MuiInputLabel-root": {
                      fontSize: "14px", 
                      top: "-3px"
                    },
                    "&::-webkit-scrollbar": {
                      width: "6px",
                    },
                  }}
                />
              )}
            />
          </div>

          <div>
            <Label>
              Select Skill <Required>*</Required>
            </Label>
            <Autocomplete
              options={skills}
              value={form.skill || null}
              disabled={!form.technology}
              onChange={(event, newValue) => {
                setForm((prev) => ({
                  ...prev,
                  skill: newValue || ""
                }));
              }}
              popupIcon={
                  <img
                    src={process.env.PUBLIC_URL + "/images/Home/sort-arrow.svg"}
                    alt="dropdown"
                    style={{ width: 16, height: 16,
                      opacity: !form.technology ? 0.3 : 1,
                      transition: "opacity 0.2s ease"
                     }}
                  />
                }
                forcePopupIcon={true}
                ListboxProps={{
                  sx: {
                    "& .MuiAutocomplete-option": {
                      fontSize: "14px",
                      padding: "6px 12px",
                    },
                  },
                }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Select Skill"
                  size="small"
                  sx={{
                    width: 300,
                    "& .MuiOutlinedInput-root": {
                      height: 32,
                      borderRadius: 0,
                      fontSize: "14px",
                      display: "flex",
                      alignItems: "center",
                    },
                    "& .MuiInputBase-input": {
                      padding: "6px 10px",
                    },
                    "& .MuiInputLabel-root": {
                      fontSize: "14px", 
                      top: "-3px"
                    },
                    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#7500C0",
                    },

                    "& .MuiInputLabel-root.Mui-focused": {
                      color: "#7500C0",
                    },
                  }}
                />
              )}
            />
          </div>

            <div>
              <Label>
                Type your query/challenge <Required>*</Required>
              </Label>
              <TextArea
                multiline
                fullWidth
                name="body"
                value={form.body}
                onChange={handleChange}
              />
              <CounterText>
                {form.body.length} / {MAX_CHARS}
              </CounterText>
            </div>
            <div>
              <Label>Tag Employees</Label>

              <Autocomplete
                multiple
                options={employeeOptions}
                loading={employeeLoading}
                noOptionsText="No employees found"
                filterOptions={(x) => x}
                getOptionLabel={(option) => option.eid}
                onInputChange={(event, value, reason) => {
                  if (reason === "input") {
                    handleEmployeeSearch(value);
                  }
                }}
                value={form.taggedUsers}

                onChange={(event, newValue) => {
                  setForm((prev) => ({
                    ...prev,
                    taggedUsers: newValue
                  }));
                }}
                popupIcon={
                  <img
                    src={process.env.PUBLIC_URL + "/images/Home/sort-arrow.svg"}
                    alt="dropdown"
                    style={{ width: 16, height: 16,
                      transition: "opacity 0.2s ease"
                     }}
                  />
                }
                forcePopupIcon={true}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Type EID"
                    size="small"
                    sx={{
                      width: 300,
                    "& .MuiOutlinedInput-root": {
                      height: 32,
                      borderRadius: 0,
                      fontSize: "14px",
                      display: "flex",
                      alignItems: "center",
                    },
                    "& .MuiInputBase-input": {
                      padding: "6px 10px",
                      marginTop: "-5px"
                    },
                    "& .MuiInputLabel-root": {
                      fontSize: "14px", 
                    },
                    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#7500C0",
                    },

                    "& .MuiInputLabel-root.Mui-focused": {
                      color: "#7500C0",
                    },

                      "& .MuiAutocomplete-tag": {
                        maxWidth: "100px", 
                      },
                      "& .MuiAutocomplete-inputRoot": {
                        flexWrap: "nowrap",
                        overflowX: "auto",
                        overflowY: "hidden",
                        scrollbarWidth: "thin",
                        scrollbarColor: "#d3d3d3 transparent",

                        "&::-webkit-scrollbar": {
                          height: "4px", 
                        },
                        "&::-webkit-scrollbar-track": {
                          background: "transparent",
                        },
                        "&::-webkit-scrollbar-thumb": {
                          backgroundColor: "#d3d3d3", 
                          borderRadius: "10px",
                        },
                        "&::-webkit-scrollbar-thumb:hover": {
                          backgroundColor: "#bfbfbf",
                        },
                      },
                    }}
                  />
                )}
              />
            </div>
        </ModalBody>

        <ModalFooter>
          <CloseButton onClick={handleClose}>
            Close
          </CloseButton>

          <PostButton
            disabled={isDisabled}
            onClick={handlePostQuestion}
          >
            Post
          </PostButton>
        </ModalFooter>
      </ModalWrapper>
    </Overlay>
    </ThemeProvider>
  );
}

export default PostQuestionModal;